export type AssessmentDisplayMetadata = {
	title: string;
	leadText: string;
};

const EMPTY_METADATA: AssessmentDisplayMetadata = {
	title: '',
	leadText: ''
};

const isObjectRecord = (value: unknown): value is Record<string, unknown> =>
	typeof value === 'object' && value !== null && !Array.isArray(value);

const textValue = (value: unknown): string => String(value ?? '').trim();

const hasMetadata = (value: AssessmentDisplayMetadata): boolean =>
	Boolean(value.title || value.leadText);

export const isEnabledFlag = (value: unknown): boolean =>
	['y', 'yes', 'true', '1'].includes(textValue(value).toLowerCase());

const readAssessmentNodeMetadata = (source: unknown): AssessmentDisplayMetadata => {
	if (!isObjectRecord(source)) {
		return EMPTY_METADATA;
	}

	const metadata = isObjectRecord(source.metadata) ? source.metadata : {};

	return {
		title: textValue(
			source.title ??
			source.assessmentTitle ??
			source.assessment_title ??
			metadata.title ??
			metadata.assessmentTitle ??
			metadata.assessment_title
		),
		leadText: textValue(
			source.leadText ??
			source.leadtext ??
			source.lead_text ??
			metadata.leadText ??
			metadata.leadtext ??
			metadata.lead_text
		)
	};
};

export const readAssessmentMetadataFromCallout = (source: unknown): AssessmentDisplayMetadata => {
	if (!isObjectRecord(source)) {
		return EMPTY_METADATA;
	}

	const wrappedAssessmentMeta = readAssessmentNodeMetadata(source.assessment);
	if (hasMetadata(wrappedAssessmentMeta)) {
		return wrappedAssessmentMeta;
	}

	const wrappedQuizMeta = readAssessmentNodeMetadata(source.assessmentQuiz);
	if (hasMetadata(wrappedQuizMeta)) {
		return wrappedQuizMeta;
	}

	const directAssessmentMeta = readAssessmentNodeMetadata(source);
	if (hasMetadata(directAssessmentMeta)) {
		return directAssessmentMeta;
	}

	return EMPTY_METADATA;
};
